module.exports = __webpack_public_path__ + "img/00026.ffa7ac6d.webp";